import { AfterViewInit, Component, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { RedirectService } from '../../services/redirect.service';
import { take } from 'rxjs/operators';
import { CardAccount } from '../../../accounts/models/accounts.model';

interface SamlCompRouterState {
  saml?: string;
  secondLevelValidated?: boolean;
}

@Component({
    selector: 'app-saml2',
    templateUrl: './saml2.component.html',
    styleUrls: ['./saml2.component.scss'],
    standalone: false
})
export class Saml2Component implements OnInit, AfterViewInit {
  cardSsoUrl: string;
  authDomian: string;
  saml: string;
  locationState: SamlCompRouterState;

  constructor(
    private readonly location: Location,
    private readonly router: Router,
    private readonly redirectService: RedirectService
  ) {
    this.cardSsoUrl = environment.cardSsoUrl;
    this.authDomian = environment.authUrl;
    this.locationState = this.location.getState();
  }

  ngOnInit() {
    let creditAccount: Pick<CardAccount, 'secondLevelValidated'> | null = null;
    try {
      creditAccount = JSON.parse(localStorage.getItem('bestegg_credit_card_session'));
    } catch {
      localStorage.removeItem('bestegg_credit_card_session');
    }
    const isSecondLevelValidated =
      this.locationState?.secondLevelValidated ?? creditAccount?.secondLevelValidated;

    // The SAML assertion is the credential POSTed to TSYS. It is not persisted
    // in localStorage and will be absent on a fresh visit or bookmark navigation,
    // so we must bail out cleanly when it is absent rather than submitting an
    // empty SAMLResponse.
    if (!isSecondLevelValidated || !this.locationState?.saml) {
      this.router.navigate(['/customer-hub'], { state: { isLaunchingCardVerificationModal: true } });
      return;
    }

    this.saml = this.locationState.saml;
  }

  ngAfterViewInit(): void {
    if (!this.saml) {
      return;
    }
    this.redirectService
      .logCardSso(this.saml)
      .pipe(take(1))
      .subscribe({
        // wait for eev to fire before submitting form; otherwise eev will get interrupted by redirect
        next: () => {
          this.submitForm();
        },
        error: () => {
          this.submitForm();
        },
      });
  }

  submitForm() {
    document.getElementById('submit-button').click();
  }
}
